import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomer_Order_Interface, Empty_LetterRequestCustomer_Order_Interface } from 'src/app/Interface/LetterRequestCustomer_Order_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerDraftForm',
  templateUrl: './LetterRequestCustomerDraftForm.component.html',
  styleUrls: ['./LetterRequestCustomerDraftForm.component.scss']
})
export class LetterRequestCustomerDraftFormComponent implements OnInit {

  Token: String = ""
  codePeygiri: String = ""
  Letter_Form_Id: any
  canEditMainForm: boolean = false
  canDeleteHistoryRecord: boolean
  parentRefer: number = 0
  letterRequestCustomerManager: number = 0

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,

    private Alertify_Service: AlertifyService,
    private route: ActivatedRoute,
    private SubjectLetter_Service: SubjectLetterService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
  ) { }


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Letter_Form_Id = Number(this.route.snapshot.paramMap.get('id'))

    if (this.Letter_Form_Id) {
      this.OnInitail_Form();
    }
    else {
      this.Letter_Form_Id = "0"
      this.ReadData_SubjectLetter()

    }

    this.AddNewLetter = new FormGroup({
      id: new FormControl(),
      subject_id: new FormControl("0"),
      giver_name: new FormControl(null, Validators.required),
      giver_semat: new FormControl(null, Validators.required),
      draftTitle: new FormControl(null),
      codePeygiri: new FormControl(null),
      peyvast: new FormControl("1"),
      sex: new FormControl("1", Validators.required),
      bazgashtBeNamehShomareh: new FormControl(null, Validators.required),
      bazgashtBeNamehTarikh: new FormControl(null, Validators.required),
      textletter_id: new FormControl("0"),
    })

  }

  OnInitail_Form() {
    this.LetterRequestCustomer_Service.GetSingle(this.Token, this.Letter_Form_Id).subscribe(
      data => {
        this.Data_Seleted_Customer = data['cusomter']
        this.Data_Seleted_Address = data['address']
        this.letterRequestCustomerManager = data['letterRequestCustomerManager']
        this.UploadImageSrc_List = data['image']
        var temp: Letter_Interface = data['main']
        this.Letter_Form_Code = data['lettercode']
        this.Letter_Form_Code_Code = data['code']




        this.Selected_DataList_LetterRequestCustomer_Record = data['parent']
        if (this.Selected_DataList_LetterRequestCustomer_Record.id > 0) {
          this.get_Form_peyvast().setValue("1")
          this.get_Form_bazgashtBeNamehShomareh().setValue(this.Selected_DataList_LetterRequestCustomer_Record.code)
          this.get_Form_bazgashtBeNamehTarikh().setValue(this.Selected_DataList_LetterRequestCustomer_Record.persianDate)
        }




        if (data['main']['peyvast'] == true)
          this.get_Form_peyvast().setValue('1')
        else
          this.get_Form_peyvast().setValue('0')

        if (data['main']['sex'] == true)
          this.get_Form_sex().setValue('1')
        else
          this.get_Form_sex().setValue('0')

        this.get_Form_giver_name().setValue(temp.giver_name)
        this.get_Form_giver_semat().setValue(temp.giver_semat)
        this.get_Form_draftTitle().setValue(temp.draftTitle)
        this.get_Form_bazgashtBeNamehShomareh().setValue(temp.bazgashtBeNamehShomareh)
        this.get_Form_subject_id().setValue(temp.subject_id)
        this.get_Form_codePeygiri().setValue(temp.codePeygiri)

        this.codePeygiri = temp.codePeygiri;


        this.ReadData_SubjectLetter()
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#region  Form Add

  AddNewLetter: FormGroup;

  get_Form_giver_name() {
    return this.AddNewLetter.get('giver_name') as FormControl;
  }
  get_Form_codePeygiri() {
    return this.AddNewLetter.get('codePeygiri') as FormControl;
  }
  get_Form_subject_id() {
    return this.AddNewLetter.get('subject_id') as FormControl;
  }
  get_Form_giver_semat() {
    return this.AddNewLetter.get('giver_semat') as FormControl;
  }
  get_Form_draftTitle() {
    return this.AddNewLetter.get('draftTitle') as FormControl;
  }
  get_Form_peyvast() {
    return this.AddNewLetter.get('peyvast') as FormControl;
  }
  get_Form_sex() {
    return this.AddNewLetter.get('sex') as FormControl;
  }
  get_Form_bazgashtBeNamehShomareh() {
    return this.AddNewLetter.get('bazgashtBeNamehShomareh') as FormControl;
  }
  get_Form_bazgashtBeNamehTarikh() {
    return this.AddNewLetter.get('bazgashtBeNamehTarikh') as FormControl;
  }

  //#endregion

  //#region Customer
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  page: number = 0

  Edit_Customer_Record: Customer_Interface = Empty_Customer_Interface()

  Search_CodeName_Customer_Table: string = ''
  Search_Type_Customer_Table: string = '2'

  DataList_Customer: Array<Customer_List_Interface> = []
  DataList_Address: Array<Address_Interface> = []
  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()
  Data_Seleted_Address: Address_Interface = Empty_Address_Interface()

  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Token, this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }



  Set_Selected_Customer_Record(item) {
    this.Data_Seleted_Customer = item
    this.modalRef_Customer.hide()
    //this.ReadData_Initial_Customer()
  }



  //#endregion



  //#region SubjectLetter

  DataList_SubjectLetter: Array<General_Interface> = []
  ReadData_SubjectLetter() {
    this.SubjectLetter_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_SubjectLetter = data
        this.Read_Order_Operation()

      }, error => {


      }
    )
  }



  //#endregion




  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<General_Interface> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.LetterRequestCustomer_Service.uploadFile(formData,this.Token).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("The file was uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    var temp:General_Interface=Empty_General_Interface()
    temp.title = this.UploadImageSrc

    this.UploadImageSrc_List.push(temp)
    this.UploadImageSrc = ''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion


  //#region LetterRequestCustomer

  Selected_DataList_LetterRequestCustomer_Record: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  modalRef_LetterRequestCustomer: any;
  Procssing_LetterRequestCustomer: boolean = false
  Search_persianDate_LetterRequestCustomer: String = ''
  Search_code_LetterRequestCustomer: String = ''
  Search_customer_LetterRequestCustomer: String = ''

  openModal_LetterRequestCustomer(template: TemplateRef<any>) {
    this.modalRef_LetterRequestCustomer = this.modalService.show(template);
    //this.ReadData_LetterRequestCustomer()
  }

  Selected_DataList_LetterRequestCustomer: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  DataList_LetterRequestCustomer: Array<LetterRequestCustomer_List_Interface> = []
  ReadData_LetterRequestCustomer() {
    this.Procssing_LetterRequestCustomer = true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerPeyvaset(0,
      Number(this.Search_code_LetterRequestCustomer),
      this.Search_customer_LetterRequestCustomer,
      this.Token).subscribe(
      data => {
        this.DataList_LetterRequestCustomer = data
        this.Procssing_LetterRequestCustomer = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Set_Selected_LetterRequestCustomer(item) {
    this.Selected_DataList_LetterRequestCustomer_Record = item
    this.Selected_DataList_LetterRequestCustomer = item
    this.get_Form_peyvast().setValue("1")
    this.get_Form_bazgashtBeNamehShomareh().setValue(item.bazgashtBeNamehShomareh)
    this.get_Form_bazgashtBeNamehTarikh().setValue(item.bazgashtBeNamehTarikh)

    if (item.sex == true)
      this.get_Form_sex().setValue('1')
    else
      this.get_Form_sex().setValue('0')

    this.get_Form_giver_name().setValue(item.giver_name)
    this.get_Form_giver_semat().setValue(item.giver_semat)

    this.Data_Seleted_Customer.id = Number(this.Selected_DataList_LetterRequestCustomer.customerId)
    this.Data_Seleted_Customer.name = this.Selected_DataList_LetterRequestCustomer.customer + ''
    this.Data_Seleted_Customer.code = this.Selected_DataList_LetterRequestCustomer.code + ''
    this.modalRef_LetterRequestCustomer.hide()
  }

  //#endregion



  //#region Letter Order

  Data_List_Order: Array<LetterRequestCustomer_Order_Interface>
  Read_Order_Operation() {
    this.Data_List_Order = []
    this.LetterRequestCustomer_Service.GetOperation(this.Letter_Form_Id, 0, true, false, false, this.Token).subscribe(
      data => {
        this.Data_List_Order = data['result']
        this.canEditMainForm = data['canEditMainForm']
        this.canDeleteHistoryRecord = data['canDeleteHistoryRecord']
        this.parentRefer = data['parentRefer']
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Selected_Order_Operation: LetterRequestCustomer_Order_Interface = Empty_LetterRequestCustomer_Order_Interface()
  SelectedLetterRole: string = '0'
  LetterHistoryDsc: string = ''
  modalRef_Order: any;
  Data_list_LetterRole: Array<General_Interface> = []
  OpenOrderDialog(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {
    this.Data_list_LetterRole = []
    this.SelectedLetterRole = '0'
    this.LetterHistoryDsc = ''
    this.Selected_Order_Operation = item
    this.InProccessing=true
    this.LetterRequestCustomer_Service.GetUserrole(item.id,item.role_id, this.Token).subscribe(
      data => {
        this.InProccessing=false
        this.Data_list_LetterRole = data
        this.modalRef_Order = this.modalService.show(template);
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion

  //#region History

  Show_History_View: number = 0
  DataList_History: Array<LetterRequestCustomer_History_Interface> = []
  ReadHistory_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetHistory(this.Letter_Form_Id, this.Token).subscribe(
      data => {
        this.InProccessing = false
        this.Show_History_View = 1
        this.DataList_History = data
        this.ReadPeyvast_Letter()
      }
    )
  }

  DeleteLetterHistoryRecord() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.DeleteLetterHistoryRecord(Number(this.Letter_Form_Id), this.Token).subscribe(
      data => {
        this.InProccessing = false
        if (data['id'] == 1) {
          this.ReadHistory_Letter()
        }
        else {
          this.Alertify_Service.ErrorMessage("Deletion is not permitted.")
        }

      }
    )
  }

  DataList_Peyvast: Array<LetterRequestCustomer_List_Interface> = []
  canOpenPeyvast: boolean=false
  ReadPeyvast_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetPeyvast1(Number(this.Letter_Form_Id), this.Token).subscribe(
      data => {
        this.InProccessing = false
        this.DataList_Peyvast = data['result']
        this.canOpenPeyvast = data['canOpen']
      }
    )
  }

  Close_Show_History() {
    this.Show_History_View = 0
  }

  //#endregion



  //#region Note Letter

  modalRef_Note: any;
  Note_Dsc: string = ''
  OpenNoteDialog(template: TemplateRef<any>) {
    this.modalRef_Note = this.modalService.show(template);
    this.Note_Dsc = ''
  }

  SubmitNote() {
    if (!this.Note_Dsc) {
      this.Alertify_Service.ErrorMessage("Enter the description.")
    }
    else {
      this.InProccessing = true

      this.Customer_Service.AddComment(this.Note_Dsc,this.Data_Seleted_Customer.id, this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The comment was submitted successfully.")
          this.InProccessing = false
          this.Note_Dsc = ''
          this.modalRef_Note.hide()
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )
    }
  }

  //#endregion




  Letter_Form_Code: String = ''
  Letter_Form_Code_Code: String = ''
  modalRef_Code: any;

  InProccessing: boolean = false
  SubmitAddNewLetter(template: TemplateRef<any>, GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {

    this.codePeygiri = this.get_Form_codePeygiri().value;

    if (this.get_Form_subject_id().value == "0" && !this.get_Form_draftTitle().value) {
      this.Alertify_Service.ErrorMessage("Enter the title.")
    }
    else {
      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = Number(this.Letter_Form_Id)
      temp.giver_name = this.get_Form_giver_name().value
      temp.codePeygiri=this.get_Form_codePeygiri().value
      temp.subject_id = Number(this.get_Form_subject_id().value)
      temp.giver_semat = this.get_Form_giver_semat().value
      temp.draftTitle = this.get_Form_draftTitle().value
      temp.peyvast = (Number(this.get_Form_peyvast().value) == 1)
      temp.bazgashtBeNamehShomareh = this.get_Form_bazgashtBeNamehShomareh().value
      temp.sex = (this.get_Form_sex().value == "1")

      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditLetterRequestCustomer(
        temp,
        this.get_Form_bazgashtBeNamehTarikh().value,
        this.Data_Seleted_Customer,
        this.Data_Seleted_Address,
        [],
        [],
        [],
        [],
        [],
        this.UploadImageSrc_List,
        true,
        false,
        false,
        this.Selected_DataList_LetterRequestCustomer_Record.id,
        false,
        GiverUser,
        Order.goSection,
        Order.id,
        this.LetterHistoryDsc,
        this.parentRefer,
        1,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage(data.dsc + '')
            }
            else{

            this.Letter_Form_Code = data['giver_name']
            this.Letter_Form_Id = data['id']

            this.Alertify_Service.SuccessMessage("The information was saved successfully.")
            
            this.modalRef_Code = this.modalService.show(template);
            this.Read_Order_Operation()
            }
          }
        )
    }

  }

  SubmitActionLetter(GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.SubmitActionLetter(
      this.Letter_Form_Id,
      GiverUser,
      Order.goSection,
      Order.id,
      this.LetterHistoryDsc,
      this.parentRefer,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          this.InProccessing = false
          this.Read_Order_Operation()
        }
      )
  }

  
  SetLetterRequestCustomerImageShow(item: General_Interface) {

    if(item.id>0)
    {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.SetLetterRequestCustomerImageShow(item.id,this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          item.del = !item.del 
          this.InProccessing = false
        }
      )
    }
    else{
      console.log(item);
      
      item.del=!item.del
    }
  }


  SubmitAddNewLetter_Co(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {

    if (item.submit) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("Select the recipient.")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitAddNewLetter(template, Number(this.SelectedLetterRole), item)
      }
    }
    else if (item.hasRefer) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("Select the recipient.")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitActionLetter(Number(this.SelectedLetterRole), item)
      }
    }
    else {
      this.modalRef_Order.hide()
      this.SubmitActionLetter(0, item)
    }
  }


  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

}
